import { ABTestFeatures, ABTestFeatureName, ABTestType } from './ABTestFeatures';
import { StringUtility } from '@inter-ikea-kompis/utilities';
// extracts search parameters in the URL relevant to overriding whether an A/B test experiment is enabled or disabled
// If an A/B test with just these two variants, this does not support specifying a variation
// If an A/B/C... test (i.e. more than two variation groups), it is required to specify which variation you are
//  checking
//Returns whether the name (& variation if relevant) is forceEnabled or forceDisabled based only on the search parameters
export const getParamOverrides = ({ name, variation }) => {
    // e.g. ABTestFeatureName.platsaOptimizeSpaceDefaultTab => `PlatsaOptimizeSpaceDefaultTab`
    const queryNamePart = StringUtility.capitalizeFirstLetter(Object.keys(ABTestFeatureName)[Object.values(ABTestFeatureName).indexOf(name)]);
    const params = new URLSearchParams(window.location.search);
    const testType = ABTestFeatures[name];
    const isABTest = testType === ABTestType.AB;
    // Future TODO: explore removing this limitation, variations of 'A' | 'B' could work
    //   but we'd have to figure out how to handle it if the validation & enable flags contradict each other
    if (isABTest && variation) {
        throw new Error('It is not supported to specify a variation for a simple AB test');
    }
    let forceDisable = false;
    let forceEnable = false;
    if (isABTest) {
        const enableQueryName = `enable${queryNamePart}`;
        const enableQueryValue = params.get(enableQueryName);
        forceEnable = enableQueryValue === 'true';
        forceDisable = enableQueryValue === 'false';
    }
    else if (variation) {
        const variationQueryName = `variation${queryNamePart}`;
        const variationQueryValue = params.get(variationQueryName);
        if (variationQueryValue != null) {
            forceEnable = variationQueryValue === variation;
            forceDisable = !forceEnable;
        }
    }
    return {
        forceDisable,
        forceEnable
    };
};
//# sourceMappingURL=getParamOverrides.js.map